import { Routes, Route } from "react-router-dom";
import { createProtectedRoute, handleUnknownRoute } from "../utils/routeUtils";


import Home from "../components/Home";
import Report from "../components/Report";
import CompletedTodayAdmin from "../components/Home/CompletedTodayAdmin";
import VoidToday from "../components/Home/VoidToday";
import ItemReport from "../components/Home/ItemReport";


import Bill from "../components/Bill";
import Stats from "../components/Stats";
import Timeline from "./../components/Timeline/index";
import Performance from "./../components/Performance/index";
import Credit from './../components/Credit/Credit';
import CombineChart from "./../components/Charts/combineChart";
import Detail from "../components/Inventory/Detail";
import Invent from "../components/Invent";
import User from "../components/User";
import Statement from "../components/Inventory/Statement";
import ItemList from "../components/Selectitem/ItemList";
import MenuMaster from "../components/MenuMaster/MenuMaster";
import ItemData from "../components/MenuMaster/ItemData";
import ReportTable from "../components/ReportTable/reportTable";
import FileUpload from "../components/MenuMaster/FileUpload";
import EditMenu from "../components/MenuMaster/EditMenuData";
import History from "../components/CustomerPortal";
import DetailedPurchaseReport from "../components/Invent/detailedpurchase/DetailedPurchaseReport";
import EmployeeAnalysis from "../components/Employee/EmployeeAnalysis";
import EmployeeDetails from "../components/Employee/EmployeeDetails";
import CostCenter from "../components/Invent/RequisitionCenter/CostCenter";


import PurchaseEntry from "../components/Invent/PurchaseEntry";
import ReceivePurchase from "../components/Invent/ReceivePurchase";
import OrderHistory from "../components/Invent/OrderHistory";
import StockExpiry from "../components/Invent/StockExpiry";
import CreateReq from "../components/Invent/RequisitionCenter/CreateReq";
import StoreReqsIssued from "../components/Invent/RequisitionCenter/StoreReqsIssued";
import WastageReport from "../components/Invent/RequisitionCenter/WastageReport";


import AddUnit from "../components/MenuMaster/RecipeCost/AddUnit";
import MenuCostPrice from "../components/MenuMaster/RecipeCost/MenuCostPrice";
import ViewUnitDefinitions from "../components/MenuMaster/RecipeCost/ViewUnitDefinitions";
import SubRecipeCost from "../components/MenuMaster/RecipeCost/SubRecipeCost";
import ViewSubRecipe from "../components/MenuMaster/RecipeCost/ViewSubRecipe";
import ViewRecipeItems from "../components/MenuMaster/RecipeCost/ViewRecipeItems";
import MenuEngieering from "../components/MenuEngineering/MenuEngineering";
import ReceivedInventory from "../components/MenuEngineering/ReceivedInventory";
import AddOpeningCount from "../components/MenuEngineering/AddOpeningCount";
import AddWastage from "../components/MenuEngineering/AddWastage";
import AddPhysicalCount from "../components/MenuEngineering/AddPhysicalCount";
import CostingAnalysis from "../components/MenuEngineering/CostingAnalysis/CostingAnalysis";
import InventoryHistory from "../components/MenuEngineering/InventoryHistory/InventoryHistory";
import InventoryCalculation from "../components/MenuEngineering/InventoryCalculation/InventoryCalculation";


// import CentralKitchenProductionHistory from "../components/CentralKitchen/ProdutionHistory";
// import CentralKitchenProduction from "../components/CentralKitchen/CentralKitchenProduction";
// import ConversionFactor from "../components/CentralKitchen/ConversionFactor/ConversionFactor";
// import CentralKitchenInventoryCalculator from "../components/CentralKitchen/InventoryCalculator/CentralKitchenInventCal";
// import CentralKitchenWastage from "../components/CentralKitchen/InventoryCalculator/CentralKitchenWastage";
// import CentralKitchenOpening from "../components/CentralKitchen/InventoryCalculator/CentralKitchenOpening";
// import CentralKitchenPhysical from "../components/CentralKitchen/InventoryCalculator/CentralKitchenPhysical";
// import CentralKitchenSnapshot from "../components/CentralKitchen/CostingAnalysis/CentralKitchenSnapshot";
// import CentralKitchenCosting from "../components/CentralKitchen/CostingAnalysis/CentralKitchenCosting";


import PredictSales from "../components/SalesPredict";
import ForecastDetails from "../components/SalesPredict/ForecastDetails";
import AddCustomerLoyalty from "../components/CustomerPortal/AddCustomerLoyalty";


import SendMessageLayout from "../components/SendMessage/SendMessageLayout";
import TableAnalyticsPage from "../components/TableAnalytics/TableAnalyticsPage";
import ItemSalesComparison from "../components/F&BComparison/ItemSalesComparison";


import MenuUpload from "../components/MenuUpload/MenuUpload";
import UploadedMenuPage from "../components/MenuUpload/UploadedMenuPage";


import AccountingLayout from "../components/Finance&Accounting/AccountingLayout";


import KitchenLayout from "../components/Home/Kitchen/KitchenSidebar";
import VoidTodayKitchen from "../components/Home/Kitchen/VoidTodayKitchen";
import ReportForKitchen from "../components/Home/Kitchen/Report/ReportForKitchen";
import KitchenItemReport from "../components/Home/ItemReport/KitchenItemReport";
import CompletedTodayKitchen from "../components/Home/Kitchen/CompleteTodayKitchen";


const kitchenRoutes = [
  { path: "home", element: <Home /> },
  { path: "void-today", element: <VoidTodayKitchen /> },
  { path: "completed-today", element: <CompletedTodayKitchen /> },
  { path: "report", element: <ReportForKitchen /> },
  { path: "items-report", element: <KitchenItemReport /> },
];


const protectedRoutes = [
  createProtectedRoute("/home", <Home />),
  createProtectedRoute("/report", <Report />),
  createProtectedRoute("/completed-today", <CompletedTodayAdmin />),
  createProtectedRoute("/void-today", <VoidToday />),
  createProtectedRoute("/items-report", <ItemReport />),


  createProtectedRoute("/bill", <Bill />),
  createProtectedRoute("/customerportal", <History />),
  createProtectedRoute("/stats", <Stats />),
  createProtectedRoute("/timeline", <Timeline />),
  createProtectedRoute("/performance", <Performance />),
  createProtectedRoute("/credit", <Credit />),
  createProtectedRoute("/user", <User />),
  createProtectedRoute("/salesreport", <ReportTable />),
  createProtectedRoute("/fileupload", <FileUpload />),
  createProtectedRoute("/editmenudata", <EditMenu />),
  createProtectedRoute("/employeeanalysis", <EmployeeAnalysis />),
  createProtectedRoute("/employeedetails", <EmployeeDetails />),


  createProtectedRoute("/inventory", <Invent />),
  createProtectedRoute("/detailedpurchasereport", <DetailedPurchaseReport />),
  createProtectedRoute("/statement", <Statement />),
  createProtectedRoute("/costcenter", <CostCenter />),
  createProtectedRoute("/items", <ItemList />),
  createProtectedRoute("/detail", <Detail />),
  createProtectedRoute("/show-all-chart", <CombineChart />),
  createProtectedRoute("/menu", <MenuMaster />),
  createProtectedRoute("/itemdata", <ItemData />),


  createProtectedRoute("/purchase-entry", <PurchaseEntry />),
  createProtectedRoute("/receive-purchase", <ReceivePurchase />),
  createProtectedRoute("/order-history", <OrderHistory />),
  createProtectedRoute("/item-expiry", <StockExpiry />),
  createProtectedRoute("/create-store-req", <CreateReq />),
  createProtectedRoute("/store-reqs", <StoreReqsIssued />),
  createProtectedRoute("/wastage-report", <WastageReport />),


  createProtectedRoute("/additemunit", <AddUnit />),
  createProtectedRoute("/menuitemcost", <MenuCostPrice />),
  createProtectedRoute("/viewrecipeitems", <ViewRecipeItems />),
  createProtectedRoute("/viewunitdefinitions", <ViewUnitDefinitions />),
  createProtectedRoute("/subrecipecost", <SubRecipeCost />),
  createProtectedRoute("/viewsubrecipes", <ViewSubRecipe />),
  createProtectedRoute("/menuengineering", <MenuEngieering />),
  createProtectedRoute("/inventorycalculation", <InventoryCalculation />),
  createProtectedRoute("/inventoryreceived", <ReceivedInventory />),
  createProtectedRoute("/addopeningcount", <AddOpeningCount />),
  createProtectedRoute("/add-wastage", <AddWastage />),
  createProtectedRoute("/inventoryhistory", <InventoryHistory />),
  createProtectedRoute("/addphysicalcount", <AddPhysicalCount />),
  createProtectedRoute("/costinganalysis", <CostingAnalysis />),


  // createProtectedRoute("/central-kitchen/production", <CentralKitchenProduction />),
  // createProtectedRoute("/central-kitchen/production-history", <CentralKitchenProductionHistory />),
  // createProtectedRoute("/central-kitchen/conversion-factor", <ConversionFactor />),
  // createProtectedRoute("/central-kitchen/inventory-calculator", <CentralKitchenInventoryCalculator />),
  // createProtectedRoute("/central-kitchen/wastage", <CentralKitchenWastage />),
  // createProtectedRoute("/central-kitchen/opening-count", <CentralKitchenOpening />),
  // createProtectedRoute("/central-kitchen/physical-count", <CentralKitchenPhysical />),
  // createProtectedRoute("/central-kitchen/snapshot", <CentralKitchenSnapshot />),
  // createProtectedRoute("/central-kitchen/costing", <CentralKitchenCosting />),


  createProtectedRoute("/salespredict", <PredictSales />),
  createProtectedRoute("/forecastdetails", <ForecastDetails />),
  createProtectedRoute("/addloyalty", <AddCustomerLoyalty />),


  createProtectedRoute("/messages/*", <SendMessageLayout />),
  createProtectedRoute("/tableanalytics", <TableAnalyticsPage />),
  createProtectedRoute("/salescomparison", <ItemSalesComparison />),


  createProtectedRoute("/menu/upload", <MenuUpload />),
  createProtectedRoute("/menu/uploaded-items", <UploadedMenuPage />),


  createProtectedRoute("/accounting/*", <AccountingLayout />),
];


const MainRoutes = () => {
  const userType = localStorage.getItem("type");

  if (userType === "kitchen") {
    return (
      <Routes>
        <Route element={<KitchenLayout />}>
          {kitchenRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>
        <Route path="*" element={handleUnknownRoute()} />
      </Routes>
    );
  }

  return (
    <Routes>
      {protectedRoutes.map((route) => (
        <Route key={route.path} {...route} />
      ))}
      <Route path="*" element={handleUnknownRoute()} />
    </Routes>
  );
};

export default MainRoutes;
